<template>
  <div class="">
    <!-- 查询表单 -->
    <div>
      <el-form ref="queryParamForm" :model="queryParamForm" label-width="90px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="分类">
              <el-select
                clearable
                v-model="queryParamForm.categoryId"
                placeholder="请选择"
                @change="changeOtherOptions(true)"
              >
                <el-option
                  v-for="item in queryCategoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="品牌">
              <el-select
                clearable
                v-model="queryParamForm.brandId"
                placeholder="请选择"
                @change="getModelList(true,false)"
              >
                <el-option
                  v-for="item in queryBrandOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="机型">
              <el-select
                clearable
                v-model="queryParamForm.modelId"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="item in queryModelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="等级">
              <el-select
                clearable
                v-model="queryParamForm.gradeId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in queryGradeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="定价回收商">
              <el-select
                clearable
                v-model="queryParamForm.serviceId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in queryServiceList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-button type="primary" @click="getModelPriceListSearch"
              >查询</el-button
            >
            <el-button type="primary" @click="addBasePrice">创建</el-button>
            <!-- <el-button type="primary">批量导出</el-button>
            <el-button type="primary">批量导入</el-button>
            <a style="marginLeft:20px;" href="#" type="primary">导入模板下载</a> -->
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
      <!-- 表格 -->
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="value" label="编号"> </el-table-column>
        <el-table-column prop="name" label="价格段利润标题">
        </el-table-column>
        <el-table-column prop="serviceName" label="定价回收商">
        </el-table-column>
        <!-- <el-table-column prop="gradeName" label="等级"> </el-table-column> -->
        <el-table-column prop="categoryName" label="分类"> </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1">启用</span>
            <span v-else>不启用</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="editormodel(scope.row)" type="text" size="small"
              >编辑</el-button
            >
            <el-button
              @click="changeStatus(scope.row, 1)"
              type="text"
              size="small"
              v-if="scope.row.status === 0"
              >启用</el-button
            >
            <el-button
              @click="changeStatus(scope.row, 0)"
              type="text"
              size="small"
              style="color: red;"
              v-else
              >不启用</el-button
            >
             <el-button @click="deletePriceCost(scope.row.id)" type="text" size="small" style="color: red;">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal"
      >
      </el-pagination>
    </div>

    <!-- 修改或新建对话框 -->
    <el-dialog
      :title="
        dlgType === 'change'
          ? '编辑机型等级价格段利润'
          : '新建机型等级价格段利润'
      "
      :visible.sync="isDlg"
      width="700px"
    >
      <div style="margin: 20px;">
        <div>
          <el-form
            ref="editBasePriceForm"
            :model="editBasePriceForm"
            :rules="editorFormRules"
            label-width="130px"
            label-position="left"
          >
            <el-form-item label="编号" v-if="dlgType === 'change'">
              <el-input
                clearable
                v-model="editBasePriceForm.value"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="价格段利润标题" prop="name">
              <el-input
                clearable
                v-model="editBasePriceForm.name"
              ></el-input>
            </el-form-item>
            <el-form-item label="定价回收商" prop="serviceId">
              <el-select
                clearable
                v-model="editBasePriceForm.serviceId"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="item in queryServiceList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="分类" prop="categoryId">
              <el-select
                clearable
                v-model="editBasePriceForm.categoryId"
                placeholder="请选择"
                @change="changeOtherOptions(false)"
              >
                <el-option
                  v-for="item in queryCategoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
             <el-form-item label="品牌" prop="brandId">
              <el-select
                clearable
                v-model="editBasePriceForm.brandId"
                placeholder="请选择"
                @change="getModelList(false,true)"
              >
                <el-option
                  v-for="item in editBrandOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="机型" prop="modelScope">
              <el-select
                  clearable
                  v-model="editBasePriceForm.modelScope"
                  placeholder="请选择"

              >
                <el-option
                    v-for="item in scopeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              label=""
              prop="modelIdList"
              class="topselect w130 ml15"
              v-show="editBasePriceForm.modelScope===1"
            >
             <el-row>
               <el-col>
                  <el-select
                    clearable
                    style="width:100%"
                    v-model="modelIdList"
                    filterable
                    multiple
                    remote
                    placeholder="请输入关键词"
                    reserve-keyword
                    :loading="loading"
                    @change="getSelectValue(modelIdList)"
                  >
                    <el-option
                      v-for="item in editModelList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
               </el-col>
               <el-col>
                  <el-checkbox v-model="allSelectFlag" @change="selectModel">全部机型</el-checkbox>
               </el-col>
             </el-row>
            </el-form-item>
            <el-form-item label="适用商户" prop="merchantScope">
              <el-select
                  clearable
                  v-model="editBasePriceForm.merchantScope"
                  placeholder="请选择"

              >
                <el-option
                    v-for="item in merchantScopeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
              <el-form-item
              label="商户"
              prop="merchantIdList"
              class="topselect w130 ml15"
              v-show="editBasePriceForm.merchantScope===1"
            >
             <el-row>
               <el-col>
                  <el-select
                    clearable
                    style="width:100%"
                    v-model="merchantIdList"
                    filterable
                    multiple
                    remote
                    placeholder="请输入关键词"
                    reserve-keyword
                    :loading="loading"
                    @change="getSelectMerchantValue(merchantIdList)"
                  >
                    <el-option
                      v-for="item in editMerchantList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
               </el-col>
               <el-col>
                  <el-checkbox v-model="allSelectMerchantFlag" @change="selectMerchant">全部商户</el-checkbox>
               </el-col>
             </el-row>
            </el-form-item>
               <el-form-item
              label="等级"
              prop="gradeIdList"
              class="topselect w130 ml15"
            >
             <el-row>
               <el-col>
                  <el-select
                    clearable
                    style="width:100%"
                    v-model="gradeIdList"
                    filterable
                    multiple
                    remote
                    placeholder="请输入关键词"
                    reserve-keyword
                    :loading="loading"
                      @change="getSelectGradeValue(gradeIdList)"
                  >
                    <el-option
                      v-for="item in editGradeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
               </el-col>
               <el-col>
                  <el-checkbox v-model="allSelectGradeFlag" @change="selectGrade">全部等级</el-checkbox>
               </el-col>
             </el-row>
            </el-form-item>
            <div>
               <div>
                  <el-row :gutter="10" style="margin-bottom:20px">
                    <el-col :span="16"><span style="color:red">* </span>价格段</el-col>
                    <el-col  :span="7"><span style="color:red">* </span>预留利润-1单</el-col>
                    <!-- <el-col  :span="4"><span style="color:red">* </span>预留利润-2单</el-col>
                    <el-col  :span="4"><span style="color:red">* </span>预留利润-3单</el-col> -->
                    <el-col  :span="1"></el-col>
                  </el-row>
                  </div>
                  <div
                      v-for="(item, itemIndex) in profitCombProject"
                      :key="item.id"
                      style="margin-bottom:4px"
                    >
                      <profit-item
                        :profit-item-object="item"
                        :item-index="itemIndex"
                        @deleteProfitItem="deleteProfitItem"
                      ></profit-item>
                   
                    </div>
                    <el-button
                      icon="el-icon-circle-plus-outline"
                      @click="addCondition(itemIndex)"
                    ></el-button>
            </div>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button
            type="primary"
            style="margin: 30px 20px;"
            @click="submitEditor"
            >确定</el-button
          >
          <el-button style="margin: 10px 20px;" @click="closeEditormodelDlg"
            >暂不</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      // 查询数据
      queryParamForm: {
        categoryId: null,
        brandId: null,
        modelId: null,
        gradeId: null,
        serviceId: null,
      },

      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,


      scopeOptions: [{
        value: 0,
        label: '通用'
      }, {
        value: 1,
        label: '部分机型'
      },],

      merchantScopeOptions: [{
        value: 0,
        label: '通用'
      }, {
        value: 1,
        label: '部分商户'
      },],


      profitCombProject:[{
        priceStart: null,
        priceEnd: null,
        price: null,
        // secondPrice:null,
        // thirdPrice:null
      }],

      // 新建编辑对话框数据

      isDlg: false,
      editBasePriceForm: {
        id: null,
        name: null,
        value: null,
        profitCondition: null,
        categoryId: null,
        modelScope:null,
        modelId: null,
        gradeId: null,
        brandId: null,
        serviceId: null,
        merchantScope:null,
        merchantId:null,
        modelIdList: [],
        merchantIdList: [],
        gradeIdList:[]
      },

      editorFormRules: {
        name: [
          { required: true, message: "请输入名称", trigger: "change" },
        ],
        merchantIdList: [
          { required: false, message: "请选择商户", trigger: "change" },
        ],
        modelIdList: [
          { required: false, message: "请选择机型", trigger: "change" },
        ],
        brandId: [
          { required: true, message: "请选择品牌", trigger: "change" },
        ],
        categoryId: [
          { required: true, message: "请选择分类", trigger: "change" },
        ],
        gradeIdList: [
          { required: true, message: "请选择等级", trigger: "change" }
        ],
        serviceId: [
          { required: true, message: "请选择回收商", trigger: "change" },
        ],modelScope: [
          {required: true, message: "请选择机型适用范围", trigger: "change"},
        ],merchantScope: [
          {required: true, message: "请选择商户适用范围", trigger: "change"},
        ],
      },

      dlgType: "change",

      // 选择
      loading: false,

      modelIdList: [],

      queryCategoryOptions: [],
      queryBrandOptions: [],
      queryServiceList: [],
      queryGradeList: [],
      queryModelList: [],

      editGradeList: [],
      editModelList: [],
      editBrandOptions: [],

      merchantIdList:[],
      editMerchantList:[],

      gradeIdList:[],

      isRefresh: false,
      allSelectFlag:false,
      allSelectMerchantFlag:false,
      allSelectGradeFlag:false
    };
  },
  watch: {},
  computed: {},
  methods: {
     deletePriceCost(id){
      let self = this
        self.$confirm('是否删除').then(() => {
         self.$api.deletePriceCost({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            self.getModelPriceListSearch();
          }
      })
      })
     
    },
      selectModel(val){
          this.modelIdList=[]
          if(val){
            this.editModelList.forEach(item=>{
                  this.modelIdList.push(item.id)
            })
          }
          this.editBasePriceForm.modelIdList = this.modelIdList;
      },
      deleteProfitItem(itemIndex){
      let self = this
      this.profitCombProject.splice(itemIndex,1);
      self.isRefresh = false;
        this.$nextTick(() => {
          self.isRefresh = true;
        });
    },
    addCondition() {
      this.profitCombProject.push({
        priceStart: null,
        priceEnd: null,
        price: null,
       });
    },
    getSelectValue(values) {
      let self = this;
      self.$set(self.editBasePriceForm, "modelIdList", values);
      if(self.modelIdList.length==self.editModelList.length){
        self.allSelectFlag = true
      }else{
         self.allSelectFlag = false
      }
    },
    getSelectMerchantValue(values) {
      let self = this;
      self.$set(self.editBasePriceForm, "merchantIdList", values);
      if(self.merchantIdList.length==self.editMerchantList.length){
        self.allSelectMerchantFlag = true
      }else{
         self.allSelectMerchantFlag = false
      }
      
    },
    selectMerchant(val){
          this.merchantIdList=[]
          if(val){
            this.editMerchantList.forEach(item=>{
                  this.merchantIdList.push(item.id)
            })
          }
          this.$set(this.editBasePriceForm, "merchantIdList", this.merchantIdList);
      },
    getSelectGradeValue(values) {
      let self = this;
      self.$set(self.editBasePriceForm, "gradeIdList", values);
      if(self.gradeIdList.length==self.editGradeList.length){
        self.allSelectGradeFlag = true
      }else{
         self.allSelectGradeFlag = false
      }
    },
    selectGrade(val){
          this.gradeIdList=[]
          if(val){
            this.editGradeList.forEach(item=>{
                  this.gradeIdList.push(item.id)
            })
          }
          this.editBasePriceForm.gradeIdList = this.gradeIdList;
      },
    //改变分类，品牌和等级集合发生变化
    async changeOtherOptions(isQuery) {
      let self = this;
      if (isQuery) {
        this.$set(this.queryParamForm, "brandId", null);
        this.$set(this.queryParamForm, "gradeId", null);
        this.$set(this.queryParamForm, "modelId", null);
        this.$set(this, "queryModelList", []);
        this.$set(this, "queryBrandOptions", []);
      } else {
        this.$set(this.editBasePriceForm, "brandId", null);
        this.$set(this.editBasePriceForm, "gradeId", null);
        this.$set(this.editBasePriceForm, "modelId", null);
        this.$set(this, "editModelList", []);
        this.$set(this, "editBrandOptions", []);
      }
      self.getBrandOptions(isQuery,!isQuery);
      self.getGradeList(isQuery);
    },
    //品牌
    async getBrandOptions(isQuery,isChange) {
      let categoryId = isQuery
        ? this.queryParamForm.categoryId
        : this.editBasePriceForm.categoryId;
      if(isChange){
         this.$set(this.editBasePriceForm, "modelIdList", []);
         this.$set(this, "modelIdList", []);
      }
      if (categoryId === "") {
        this.$set(this, isQuery ? "queryBrandOptions" : "editBrandOptions", []);
      } else {
        let self = this;
        self.$api
          .getClass({
            categoryId: categoryId,
            typeKey: "phoneBrand",
            status: 1,
            page: 1,
            size: 100000,
          })
          .then((res) => {
            isQuery
              ? (self.queryBrandOptions = res.data.records || [])
              : (self.editBrandOptions = res.data.records || []);
          });
      }
    },
    //机型
   async getModelList(isQuery,isChange) {
      let brandId = isQuery
        ? this.queryParamForm.brandId
        : this.editBasePriceForm.brandId;
      isQuery
        ? this.$set(this.queryParamForm, "modelId", null)
        : this.$set(this.editBasePriceForm, "modelId", null);
      if(isChange){
         this.$set(this.editBasePriceForm, "modelIdList", []);
         this.$set(this, "modelIdList", []);
      }
      if (brandId === "") {
        this.$set(this, isQuery ? "queryModelList" : "editModelList", []);
      } else {
        let self = this;
        self.$api
          .getClass({
            brandId: brandId,
            typeKey: "phoneModal",
            status: 1,
            page: 1,
            size: 100000,
          })
          .then((res) => {
            isQuery
              ? (self.queryModelList = res.data.records || [])
              : (self.editModelList = res.data.records || []);
            self.allSelectFlag = false
            if(self.modelIdList!=null&&self.modelIdList.length>0&&self.modelIdList.length==self.editModelList.length){
              self.allSelectFlag = true
            }
          });
      }
    },
    //等级
   async getGradeList(isQuery) {
      let self = this;
      let categoryId = isQuery
        ? this.queryParamForm.categoryId
        : this.editBasePriceForm.categoryId;
      if (categoryId === "") {
        this.$set(this, isQuery ? "queryGradeList" : "editGradeList", []);
      } else {
        this.$api
          .getValidModelGrade({
            categoryId: categoryId,
          })
          .then((res) => {
            isQuery
              ? (self.queryGradeList = res.data || [])
              : (self.editGradeList = res.data || []);
          });
      }
    },
    //回收商集合
    getServiceList() {
      let self = this;
      this.$api.getValidHjxServiceProvider().then((res) => {
        self.queryServiceList = res.data || [];
      });
    },
    // 分页函数
    handleSizeChange(val) {
      console.log(val);
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.currentPage = val;

      // 重新请求表格数据
      this.getModelPriceListSearch();
    },

    // 获取表格数据
    getModelPriceListSearch() {
      let self = this;
      self.$api
        .modelProfitListSearch({
          page: self.currentPage,
          size: self.pageSize,
          categoryId: self.queryParamForm.categoryId || null,
          brandId: self.queryParamForm.brandId || null,
          modelId: self.queryParamForm.modelId || null,
          serviceId: self.queryParamForm.serviceId || null,
          gradeId: self.queryParamForm.gradeId || null,
        })
        .then((res) => {
          self.tableData = res.data.records || [];
          self.tableTotal = res.data.total;
        });
    },

    // 添加
    addBasePrice() {
      this.dlgType = "new";
      this.editBasePriceForm = {};
      this.$nextTick(()=>{
          this.$refs['editBasePriceForm'].clearValidate()
      })
      this.editGradeList = []
      this.editModelList = []
      this.editBrandOptions = []
      this.modelIdList = []
      this.merchantIdList = []
      this.gradeIdList = []
      this.profitCombProject=[{}]
      this.isDlg = true
      this.allSelectFlag = false
      this.allSelectMerchantFlag = false
      this.allSelectGradeFlag = false
    },

    // 修改
   async editormodel(row) {
      let self = this;
      self.allSelectFlag = false
      self.dlgType = "change";
      self.$set(self, "modelIdList", []);
      self.$set(self, "merchantIdList", []);
      self.$set(self, "gradeIdList", []);
      self.$set(self.editBasePriceForm, "modelIdList", []);
      self.$set(self.editBasePriceForm, "merchantIdList", []);
      self.$set(self.editBasePriceForm, "gradeIdList", []);
      self.editBasePriceForm = JSON.parse(JSON.stringify(row));
      self.profitCombProject = JSON.parse(row.profitCondition)
      const modelId = self.editBasePriceForm.modelId;
      if(modelId != null){
        self.modelIdList = modelId.split(",");
      }
      const merchantId = self.editBasePriceForm.merchantId;
      if(merchantId != null){
        self.allSelectMerchantFlag = false
        self.merchantIdList = merchantId.split(",");
      }
      const gradeId = self.editBasePriceForm.gradeId;
      if(gradeId != null){
        self.allSelectGradeFlag = false
        self.gradeIdList = gradeId.split(",");
      }
      await self.getBrandOptions(false,false);
      await self.getModelList(false,false);
      await self.getGradeList(false);
      this.isDlg = false;
      this.$nextTick((e) => {
        self.$set(self.editBasePriceForm, "gradeId", row.gradeId);
        self.modelIdList = self.modelIdList.map((i) => parseInt(i, 0));
        self.$set(self.editBasePriceForm, "modelIdList", self.modelIdList);
        if(self.merchantIdList!=null&&self.merchantIdList.length>0){
          self.merchantIdList = self.merchantIdList.map((i) => parseInt(i, 0));
          self.allSelectMerchantFlag = false
          if(self.merchantIdList!=null&&self.merchantIdList.length>0&&self.merchantIdList.length==self.editMerchantList.length){
            self.allSelectMerchantFlag = true
          }
          self.$set(self.editBasePriceForm, "merchantIdList", self.merchantIdList);
        }
        if(self.gradeIdList!=null&&self.gradeIdList.length>0){
          self.gradeIdList = self.gradeIdList.map((i) => parseInt(i, 0));
          self.allSelectGradeFlag = false
          if(self.gradeIdList!=null&&self.gradeIdList.length>0&&self.gradeIdList.length==self.editGradeList.length){
            self.allSelectGradeFlag = true
          }
          self.$set(self.editBasePriceForm, "gradeIdList", self.gradeIdList);
        }
        self.isDlg = true;
      });
    },


    // 关闭编辑对话框
    closeEditormodelDlg() {
      this.isDlg = false;
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs["editBasePriceForm"].validate((valid) => {
        if (valid) {
          let params = this.editBasePriceForm;
          if(self.profitCombProject==null||self.profitCombProject.length<=0){
                      this.$message({
                        message: "请设置价格段利润规则",
                        type: "error",
                      }); 
                      return
          }
            for(let i=0;i<self.profitCombProject.length;i++){
                 var item = self.profitCombProject[i]
                 if(item.priceStart==''||item.priceEnd==''||item.price==''||
                 item.priceStart==null||item.priceEnd==null||item.price==null){
                      this.$message({
                        message: "价格段利润设置值不能为空",
                        type: "error",
                      }); 
                      return
                 }
            }
          params.profitCondition = JSON.stringify(self.profitCombProject)

          if (params.modelScope === 0) {
            params.modelId = null;
          } else {
            params.modelId = this.modelIdList.join(",");
          }

          if (params.merchantScope === 0) {
            params.merchantId = null;
          } else {
            params.merchantId = this.merchantIdList.join(",");
          }
          
          params.gradeId = this.gradeIdList.join(",");
          self.$api.updateModelProfit(params).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              self.getModelPriceListSearch();
              self.closeEditormodelDlg();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getCategroyOptions() {
      let self = this;
      this.$api
        .getClass({
          typeKey: "category",
          status: 1,
          page: 1,
          size: 100000,
        })
        .then((res) => {
          self.queryCategoryOptions = res.data.records || [];
        });
    },

    changeStatus(row, newStatus) {
      let self = this;
      // row.status = newStatus;
      let temp={id:row.id,status:newStatus}
      this.$api.updateModelProfit(temp).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          self.getModelPriceListSearch();
        }
      });
    },

    //有效商户
    getValidMerchant(){
       let self = this;
      this.$api.getValidMerchant().then((res) => {
        self.editMerchantList = res.data
      })
    }
  },
  created() {},
  mounted() {
    let self = this;
    self.getModelPriceListSearch();
    self.getCategroyOptions();
    self.getServiceList();
    self.getValidMerchant();
  },
};
</script>
<style lang="less" scoped>
.topselect {
  ::v-deep {
    .el-input__inner {
      height: 120px;
    }

    .el-input__prefix,
    .el-input__suffix {
      height: 120px;
    }

    /* 下面设置右侧按钮居中 */
    .el-input__suffix {
      top: 5px;
    }

    .el-input__icon {
      line-height: inherit;
    }

    .el-input__suffix-inner {
      display: inline-block;
    }
  }
}
</style>
